export const FETCH_ROOT_PRODUCT_CATEGORY = 'FETCH_ROOT_PRODUCT_CATEGORY';
export const FILTER_ROOT_PRODUCT_CATEGORY = 'FILTER_ROOT_PRODUCT_CATEGORY';